import type { TextStyle } from '../types';

export enum TextObject2EditMode {
  STATIC = 'static',
  CLICK_TO_EDIT = 'click_to_edit',
  OPEN_TO_EDIT = 'open_to_edit',
  OPEN_TO_SELECT = 'open_to_select',
}

export type Segment = {
  text: string;
  visibleText: string;
  width: number; // measured in THIS segment's resolved style
  style: TextStyle; // fully-resolved merged style
};

export type Line = {
  text: string;
  visibleText: string;
  width: number;
  height: number;
  yPosition: number;
  segments?: Segment[]; // present only for rich-text lines
};
